import { render, staticRenderFns } from "./AttendSupperEdit.vue?vue&type=template&id=22ad208a&scoped=true&"
import script from "./AttendSupperEdit.vue?vue&type=script&lang=js&"
export * from "./AttendSupperEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad208a",
  null
  
)

export default component.exports